import { render, staticRenderFns } from "./SwappTasksListTasks.vue?vue&type=template&id=4fe729dc&scoped=true&"
import script from "./SwappTasksListTasks.vue?vue&type=script&lang=js&"
export * from "./SwappTasksListTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe729dc",
  null
  
)

export default component.exports